// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { HttpClient } from '@angular/common/http';
import { AsyncPipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import moment from 'moment';
import { ScreenLayoutService } from 'src/app/modules/shared/services/screen-layout-service/screen-layout.service';
import { PortalWebAppConfigurationService } from '../../services/portal-web-app-configuration.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [TranslateModule, AsyncPipe],
})
export class FooterComponent {
  protected moment = moment;
  private readonly http = inject(HttpClient);
  public configurationService = inject(PortalWebAppConfigurationService);
  public screenLayoutService = inject(ScreenLayoutService);

  protected privacyLink =
    'https://carl.siemens.cloud/api-carl/file?id=245fe341-488b-4456-af7f-a9310108351b';
  protected termsOfUse =
    'https://healthineers.sharepoint.com/SitePages/Terms-of-Use.aspx';

  protected get termsOfUseChinese(): string {
      return this.configurationService.getTermsOfUseChinaApiPath();
    }

  openTermsOfUseChinese(event: Event): void {
    event.preventDefault();
    const targetWindow = globalThis.open('', '_blank');
    this.http.get(this.termsOfUseChinese, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        const objectUrl = URL.createObjectURL(blob);
        if (targetWindow) {
          targetWindow.location.href = objectUrl;
        } else {
          globalThis.open(objectUrl, '_blank');
        }
        globalThis.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
      },
      error: () => targetWindow?.close(),
    });
  }

  openFeedbackForm(): void {
    globalThis.open(
      this.configurationService.getPortalWebAppConfiguration().feedbackFormUrl,
      '_blank',
    );
  }
}
